import React, { useState, useEffect } from "react";
import useUpdateRfid from "../../hooks/useUpdateRfid";

export default function UpdateRfidModal({ isOpen, rfid, onClose, onSuccess }) {
  const { updateRfid, isUpdating, error } = useUpdateRfid();

  const [formData, setFormData] = useState({
    status: "",
    expiry_date: "",
  });

  useEffect(() => {
    if (rfid) {
      setFormData({
        status: rfid.status || "",
        expiry_date: rfid.expiry_date || "",
      });
    }
  }, [rfid]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateRfid({
        rfid: rfid.id,
        status: formData.status || undefined,
        expiry_date: formData.expiry_date || undefined,
      });
      onSuccess();
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  if (!isOpen || !rfid) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-light mb-4">Edit RFID: {rfid.id}</h2>

        {error && (
          <div className="bg-red-50 text-red-600 p-3 rounded mb-4 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-neutral-700 mb-1">
              Status
            </label>
            <input
              type="text"
              value={formData.status}
              onChange={(e) => handleChange("status", e.target.value)}
              className="w-full px-3 py-2 border border-neutral-300 rounded focus:outline-none focus:ring-2 focus:ring-neutral-900"
              placeholder="Leave empty to keep current"
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-neutral-700 mb-1">
              Expiry Date
            </label>
            <input
              type="date"
              value={formData.expiry_date}
              onChange={(e) => handleChange("expiry_date", e.target.value)}
              className="w-full px-3 py-2 border border-neutral-300 rounded focus:outline-none focus:ring-2 focus:ring-neutral-900"
              placeholder="Leave empty to keep current"
            />
          </div>

          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-neutral-300 rounded hover:bg-neutral-50 transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isUpdating}
              className="flex-1 px-4 py-2 bg-neutral-900 text-white rounded hover:bg-neutral-800 transition disabled:opacity-50"
            >
              {isUpdating ? "Updating..." : "Update RFID"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}